
<template>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau 
    </button>

    <DataTableBackend :url="'/api/types_articles'" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
  
<script >
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowTypesArticle = defineAsyncComponent(() => import('./ShowTypesArticle.vue'));
const CreateTypesArticle = defineAsyncComponent(() => import('./CreateTypesArticle.vue'));

export default defineComponent({
    name: 'IndexTypesArticle',
    data() {
        return {
            table: 'types_articles',
            baseUrl: this.$store.state.api_yams_livraisons,
            columns: [
                {
                    key: 'libelle',
                    label: 'Libelle',
                    exportable: true
                },
                {
                    key: 'montant',
                    label: 'Montant',
                    format: 'money',
                    exportable: true
                },
            ]
        };
    },
    methods: {
        openCreateModal() {
            this.$dialog.open(CreateTypesArticle, {
                props: {
                    header: "Nouveau ",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowTypesArticle, {
                props: {
                    header: "Trajet N°" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        
    },
});
</script>
    
  